import React, { FC } from 'react';
import {
  DynamicNewsContainer,
} from '../modules/dynamic-news/dynamic-news.container';
import { FooterContainer } from '../modules/footer/footer.container';


export const DynamicNews: FC = () => {
  return (
    <>
      <DynamicNewsContainer />
      <FooterContainer />
    </>
  );
};
